export default __webpack_public_path__ + "static/media/fiat_deposit.eec54ebc.svg";